import TileHolder from './TileHolder';

class TileHolderFactory {

    constructor(s, l) {
        this.s = s;
        this.l = l;
    }

    get(tile) {
        return new TileHolder(0, 0, this.s, this.l, tile);   
    }
}

export default TileHolderFactory;


// WEBPACK FOOTER //
// ./src/TileHolderFactory.jsx